import { AxiosRequestConfig } from 'axios'

export interface GenderAnalysisByLevelParams {
  startDate: string
  endDate: string
  storeId?: number
}

export interface GenderData {
  name: string
  value: number
  proportion: number
  code: string
  averageFrequency?: number
}

export interface GenderAnalysisByLevelData {
  data: GenderData[]
  totalUsers: number
}

export const getGenderAnalysisByLevel = (
  params: GenderAnalysisByLevelParams,
): AxiosRequestConfig => ({
  url: '/dashboard/gender-analysis-by-level',
  method: 'GET',
  params,
})
